import { useEffect, useState } from "react";
import { DonorService } from "../../../Services/Donor.Service";
import { AdminService } from "../../../Services/Admin.service";
import Toaster from "../../../Components/Toaster";

import { Table } from "react-bootstrap";
import SampleTypeDropdown from "../../../Components/AdministrativeSettings/SampleTypeDropdown";
import LabLocationDropdown from "../../../Components/AdministrativeSettings/LabLocationDropdown";
import LoadingComponent from "../../../Components/LoadingComponent";
import NoListDataAvailable from "../../../Components/NoListDataAvailable";
import TablePagination from "../../../Components/AdministrativeSettings/TablePagination";
import UpcomingDonationsTableRow from "../../../Components/AdministrativeSettings/DonorManagement/UpcomingDonationsTableRow";
import DateRangeFilter from "../../../Components/AdministrativeSettings/DateRangeFilter";
import NumberOfDonationSort from "../../../Components/AdministrativeSettings/NumberOfDonartionSort";
import SearchInput from "../../../Components/AdministrativeSettings/SearchInput";
import Loader from "../../../Components/Loader";
import { LabsService } from "../../../Services/Labs.service";
import { SampleService } from "../../../Services/Sample.service";
import TokenService from "../../../Services/Token.service";

function UpcomingDonationsListTable(props) {
    const [loading, setLoading] = useState(true);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [totalUpcomingDonations, setTotalUpcomingDonation] = useState(0);
    const [UpcomingDonationList, setUpcomingDonationList] = useState([]);
    
    const [samples, setSamples] = useState([]); 
    const [selectedSamples, setSelectedSamples] = useState([]);

    const [labLocations, setLabLocations] = useState([]);    
    const [selectedLabLocations, setSelectedLabLocations] = useState([]);

    const [selectedDateRange, setSelectedDateRange] =  useState([null, null]);
    const [upcomingDonationTimeSortDirection, setUpcomingDonationTimeSortDirection] = useState(null);

    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, offset: 0 });

    const [searchJob, setSearchJob] = useState("");
    const [isSearchInputVisible, setSearchInputVisible] = useState(false); 

    const { isClearFilter } = props;
    const { onFilterCountChange } = props;
    const { exportCsv } = props;
    const {selectedRange} = props;
    const {userType} = props;
    const {donorId} = props;

    const [compensationSortDirection, setCompensationSortDirection] = useState(null);

    useEffect(() => {
        if (isClearFilter) { 
            setSelectedSamples([]);
            setSearchJob("");
            setSearchInputVisible(false);
            onFilterCountChange(0);
            setSelectedLabLocations([]);
            setSelectedDateRange([null, null]); 
            setUpcomingDonationTimeSortDirection(null); 
            setCompensationSortDirection(null);
        }
    }, [isClearFilter]);

    // Calculate and update the filter count
    useEffect(() => { 
        const count = [ 
            selectedSamples.length > 0 ? 1 : 0,
            upcomingDonationTimeSortDirection !== null ? 1 : 0,
            selectedLabLocations.length  > 0 ? 1 : 0,
            searchJob ? 1 : 0,
            // selectedDateRange.length > 0 ? 1 : 0, 
            selectedDateRange[0] !== null && selectedDateRange[1] !== null ? 1 : 0, 
            compensationSortDirection !== null ? 1 : 0,
        ].reduce((sum, val) => sum + val, 0);

        onFilterCountChange(count);
    }, [ searchJob, selectedSamples,selectedLabLocations, selectedDateRange, upcomingDonationTimeSortDirection, compensationSortDirection]);

    useEffect(() => {
        if (exportCsv) {

            setLoading(true);
            const filters = {
                job_id: searchJob, 
                samples: selectedSamples,
                from_date: selectedDateRange[0],
                to_date: selectedDateRange[1],
            };          
            
            const params = {
                filters: filters,
                donor_id : donorId,

            };

            DonorService.exportUpcomingDonationList(params)
                .then((response) => {
                    if (response.success) {
                        setShowToast(true);
                        setToastMessage(response.message);
                        setToastVariant("success"); 
                        const downloadUrl = response.download_url;
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        // link.setAttribute('download', 'UpcomingDonation_export.csv');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setLoading(false);
                    } else {
                        setShowToast(true);
                        setToastMessage(response.message);
                        setToastVariant("danger");
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    setShowToast(true);
                    setToastMessage("Error exporting Upcoming Donation list.");
                    setToastVariant("danger");
                    console.error("Error exporting Upcoming Donation list:", error);
                    setLoading(false);
                });
        }
    }, [exportCsv]); 
    
    useEffect(() => { 
        fetchSampleTypes();
        fetchLabLocations();
    }, []);

    useEffect(() => {
        fetchUpcomingDonationList();
    }, [pagination, searchJob, selectedSamples,selectedLabLocations, selectedDateRange,upcomingDonationTimeSortDirection, selectedRange, compensationSortDirection]);
   
    function fetchUpcomingDonationList() {
        setLoading(true);
                
        const filters = {
            job_id: searchJob, 
            samples: selectedSamples,
            labs: selectedLabLocations,
            from_date: selectedDateRange[0],
            to_date: selectedDateRange[1],
        };
 
        const params = {
            limit: pagination.limit,
            offset: pagination.offset,
            range: selectedRange,
            filters: filters,
            donor_id:donorId,
            sort : upcomingDonationTimeSortDirection ? 'appointment_time' : (compensationSortDirection ? 'total_price' : ''),
            sort_direction : upcomingDonationTimeSortDirection ? upcomingDonationTimeSortDirection : (compensationSortDirection ? compensationSortDirection : '')
        };

        DonorService.getUpcomingDonationList(params)
        .then((response) => {
            setUpcomingDonationList(response.data.list);
            setTotalUpcomingDonation(response.data.total);              
            setLoading(false);
        })
        .catch((error) => {
            console.error("Failed to fetch UpcomingDonation list", error);
            setLoading(false);
        }); 
    }
    async function fetchLabLocations() {            
        LabsService.getLabList()
        .then((labLocations) => {
            setLabLocations(labLocations.labs);
        })
        .catch((error) => {
            console.error("Failed to fetch lab locations", error);
        });
    }
    async function fetchSampleTypes() {
        AdminService.getSampleTypes()
        .then((sampleTypes) => {
            setSamples(sampleTypes);
        })
        .catch((error) => {
            console.error("Failed to fetch sample types", error);
        });
    }
     
    const handleLabLocationChange = (labLocationId) => {
        
        if (selectedLabLocations.includes(labLocationId)) {
            setSelectedLabLocations(selectedLabLocations.filter((id) => id !== labLocationId));
        } else {
            setSelectedLabLocations([...selectedLabLocations, labLocationId]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };
    
    const handleSampleChange = (sample) => {
        if (selectedSamples.includes(sample)) {
            setSelectedSamples(selectedSamples.filter((s) => s !== sample));
        } else {
            setSelectedSamples([...selectedSamples, sample]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };

    const handleDateRangeChange = (daterange) => {       
        // Set the selected date range directly to the new range array
        setSelectedDateRange(daterange);     
        // Reset pagination whenever the date range changes
        setPagination({ ...pagination, page: 1, offset: 0 });
    };

    const handleChangeAppointmentTime = async (values) => {        
        setLoading(true);
        try {            
            const response = await DonorService.changeAppointmentTime(values);

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                fetchUpcomingDonationList();
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) {
            setToastMessage(error.response.data.message);
            setShowToast(true);
            setToastVariant('error');
            console.error("Failed to change user status:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleDeleteUpcomingDonation = async (appointment_id, note) => {

        setLoading(true);

        try {
 
            const parms = {
                appt_id: appointment_id,
                cancel_reason: note,
                canceled_by: TokenService.getUserId()
            }
            const response = await DonorService.deleteUpcomingDonation(parms);

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                console.log("Upcoming donation deleted successfully:", response);
                fetchUpcomingDonationList();
            }
            else {

                let formattedMessage = '';
                if (typeof response.message === 'object' && response.message !== null) {
                    formattedMessage = Object.keys(response.message)
                        .map((key) => `${key}: ${response.message[key].join(', ')}`)
                        .join(' | ');
                } else {                    
                    formattedMessage = response.message || 'An error occurred.';
                }

                setToastMessage(formattedMessage);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) {            
            setToastMessage(error.response.data.message);
            setShowToast(true);
            setToastVariant('error');
        } finally {
            setLoading(false);
        }
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {

        if (newRowsPerPage === 'Show All') {
            setRowsPerPage(totalUpcomingDonations);
            setPagination({ limit: totalUpcomingDonations, offset: 0, page: 1 });
        } else {
            setRowsPerPage(Number(newRowsPerPage));
            setPagination({ limit: Number(newRowsPerPage), offset: 0, page: 1 });
        }
    };

    const totalFiltered = UpcomingDonationList.length;  //ex 10 
    const totalPages = Math.ceil(totalUpcomingDonations / rowsPerPage); // 10 / 2rpp  then  5 pages

    const handleNextPage = () => {
        setPagination({ ...pagination, offset: pagination.page * rowsPerPage, page: pagination.page + 1 });
    };

    const handlePreviousPage = () => {
        setPagination({ ...pagination, offset: (pagination.page - 2) * rowsPerPage, page: pagination.page - 1 });
    };

    function handleUpcomingDonationTime(direction) {
        setUpcomingDonationTimeSortDirection(direction);
        setCompensationSortDirection(null);
        setPagination({ ...pagination, page: 1, offset: 0 });
    }

    
    function handleCompensationSort(direction) {
        setCompensationSortDirection(direction);
        setUpcomingDonationTimeSortDirection(null);
        setPagination({ ...pagination, page: 1, offset: 0 });
    }
    return (
        <>    
        <Loader loading={loading}/>
        <div className="">
            <div className="el-table-container el-board-table">
                <Table hover className="table table-striped">
                    <thead>
                        <tr>
                            <th>
                                <DateRangeFilter
                                    selectedDateRange={selectedDateRange}
                                    handleDateRangeChange={handleDateRangeChange}
                                    setSelectedDateRange={setSelectedDateRange}
                                    label ="Date Range"/>
                            </th>
                            <th> 
                                <NumberOfDonationSort handleSortDonations={handleUpcomingDonationTime} sortDirection={upcomingDonationTimeSortDirection} type="time" />
                            </th>                            
                            <th><SearchInput   label="Job #"
                                    value={searchJob}
                                    setValue={setSearchJob}
                                    isVisible={isSearchInputVisible}
                                    setVisible={setSearchInputVisible}/></th>
                            <th> <LabLocationDropdown
                                    labLocations={labLocations}
                                    selectedLabLocations={selectedLabLocations}
                                    handleLabLocationChange={handleLabLocationChange}
                                    setSelectedLabLocations={setSelectedLabLocations} /></th>
                            <th>
                                <SampleTypeDropdown
                                    samples={samples}
                                    selectedSamples={selectedSamples}
                                    handleSampleChange={handleSampleChange}
                                    setSelectedSamples={setSelectedSamples} />
                            </th>
                            {userType == "donor" && (  
                                <th>
                                    <NumberOfDonationSort handleSortDonations={handleCompensationSort} sortDirection={compensationSortDirection} type="compensation" />
                                </th>                                   
                            )}
                            <th>Actions</th>
                            </tr>
                    </thead>
                    <tbody>
                        {UpcomingDonationList.length > 0 ? (UpcomingDonationList.map((Donation, index) => (
                                <UpcomingDonationsTableRow
                                    key={index}
                                    donation={Donation}
                                    handleChangeAppointmentTime={handleChangeAppointmentTime}
                                    handleDeleteUpcomingDonation={handleDeleteUpcomingDonation}
                                    fetchDonorList={fetchUpcomingDonationList}
                                    sampleTypes={samples}
                                    userType={userType}
                                />
                            ))) : (
                                <NoListDataAvailable type="upcoming donations" />
                            )}
                    </tbody>
                </Table>
            </div>
            <TablePagination
                rowsPerPage={rowsPerPage}
                handleRowsPerPageChange={handleRowsPerPageChange}
                pagination={pagination}
                totalPages={totalPages}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
                totalUsers={totalUpcomingDonations}
            />
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </div>
        </>
    );
}

export default UpcomingDonationsListTable;